const entity = {
    create_failed: 'Fehler beim erstellen von {{name}}.',
    not_exists: '{{name}} existiert nicht.',
    not_exists_with_id: '{{name}} mit ID `{{id}}` existiert nicht.',
    not_found: 'Die Ressource wurde nicht gefunden.',
};
export default entity;
